/**
 * Registrazione Service Worker + cattura evento beforeinstallprompt.
 *
 * Espone:
 *   - registerSW()        : registra il SW (solo produzione)
 *   - getInstallPrompt()  : restituisce l'evento deferred (null se non disponibile)
 *   - promptInstall()     : mostra il prompt nativo (deve essere chiamata da gesto utente)
 */
let deferredPrompt = null;
let swRegistered = false;

function captureInstallPrompt(e) {
  e.preventDefault();
  deferredPrompt = e;
  // Notifica i listener (Topbar) che il prompt è disponibile
  window.dispatchEvent(new CustomEvent('pwa:installable', { detail: { available: true } }));
}

function registerSW() {
  if (swRegistered || typeof window === 'undefined') return Promise.resolve();
  swRegistered = true;

  if (!('serviceWorker' in navigator)) {
    console.log('[PWA] Service Worker non supportato');
    return Promise.resolve();
  }

  // In dev (Vite) non registriamo per non interferire con HMR
  if (import.meta.env.DEV) {
    console.log('[PWA] Dev mode — SW non registrato');
    return Promise.resolve();
  }

  return navigator.serviceWorker
    .register('/sw.js', { scope: '/' })
    .then((reg) => {
      console.log('[PWA] SW registrato, scope:', reg.scope);
      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        newWorker?.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            console.log('[PWA] Nuova versione disponibile — ricarica per aggiornare');
            window.dispatchEvent(new CustomEvent('pwa:update', { detail: { registration: reg } }));
          }
        });
      });
    })
    .catch((err) => console.error('[PWA] Registrazione SW fallita:', err));
}

function getInstallPrompt() {
  return deferredPrompt;
}

async function promptInstall() {
  if (!deferredPrompt) {
    console.warn('[PWA] Prompt installazione non disponibile');
    return false;
  }
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  if (outcome === 'accepted') {
    console.log('[PWA] Installazione accettata');
    deferredPrompt = null;
    window.dispatchEvent(new CustomEvent('pwa:installable', { detail: { available: false } }));
    return true;
  }
  console.log('[PWA] Installazione rifiutata');
  return false;
}

// Listener nativo (solo se SW non ancora registrato — primo caricamento)
window.addEventListener('beforeinstallprompt', captureInstallPrompt);

export { registerSW, getInstallPrompt, promptInstall };